import FastMarquee from "react-fast-marquee";

const ITEMS = [
  "IMPORTAÇÃO",
  "EXPORTAÇÃO",
  "DESPACHO ADUANEIRO",
  "ASSESSORIA ADUANEIRA",
  "SISCOMEX / RADAR",
  "COTAÇÕES PTAX",
];

const Marquee = () => (
  <div className="border-y border-navy bg-navy py-5" data-testid="editorial-marquee">
    <FastMarquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="mx-10 font-oswald text-lg uppercase tracking-[0.3em] text-white/85">
            {item}
          </span>
          <span className="font-mono text-xs text-white/30" aria-hidden="true">
            ///
          </span>
        </span>
      ))}
    </FastMarquee>
  </div>
);

export default Marquee;
